export const baseUrl = "https://api.upteen.ir";

// AUTH API
export const registerApi = baseUrl + "/api/v1/auth/register/";
export const loginApi = baseUrl + "/api/v1/auth/login/";
export const verificationEmailApi =
  baseUrl + "/api/v1/verification/tenant/email/";
export const verificationPhoneApi =
  baseUrl + "/api/v1/verification/tenant/phone/";
export const verificationApi = baseUrl + "/api/v1/verification/tenant/verify";
export const profileApi = baseUrl + "/api/v1/auth/profile/";
export const fcmTokenApi = baseUrl + "/api/v1/auth/fcm/";

// USER API
export const userApi = baseUrl + "/api/v1/subscriber/";

// GROUP API
export const groupApi = baseUrl + "/api/v1/group/";

// RESELLER API
export const tenantApi = baseUrl + "/api/v1/tenant/";

// BALANCE API
export const balanceApi = baseUrl + "/api/v1/auth/balance/";

// TRANSACTION API
export const transactionApi = baseUrl + "/api/v1/transaction/list/";
export const increaseBalanceApi = baseUrl + "/api/v1/transaction/request";
// https://api.upteen.ir/api/v1/transaction/request/uuid/value

//INVOICE API
export const invoiceApi = baseUrl + "/api/v1/invoice/";

// Forgot password API
export const resetEmailApi = baseUrl + "/api/v1/auth/password/reset/request/";
export const confirmResetEmailApi =
  baseUrl + "/api/v1/auth/password/reset/confirm/";

//notifications API
export const notificationListApi = baseUrl + "/api/v1/notification/received/";
export const notificationApi = baseUrl + "/api/v1/notification/";
export const commandApi = baseUrl + "/api/v1/notification/command/";

//missions API
export const missionApi = baseUrl + "/api/v1/notification/mission/";
